export default __webpack_public_path__ + "static/media/LS-EV-charging.395e5657.svg";